/* istanbul ignore file */

import { Location } from 'react-router-dom';

let currentLocation: Location | null = null;

export const setRouterLocation = (location: Location) => {
  currentLocation = location;
};

export const getRouterLocation = (): Location | null => currentLocation;

export const getRouterPathname = (): string => currentLocation?.pathname ?? '';

export const getRouterSearch = (): string => currentLocation?.search ?? '';
